import { render, staticRenderFns } from "./PointLabelArea.vue?vue&type=template&id=68410ad8&scoped=true&"
import script from "./PointLabelArea.vue?vue&type=script&lang=js&"
export * from "./PointLabelArea.vue?vue&type=script&lang=js&"
import style0 from "./PointLabelArea.vue?vue&type=style&index=0&id=68410ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68410ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
